import { advantageList } from '../list/advantages';

export const why = {
  title: 'Почему мы?',
  list: advantageList,
};
